module.exports = __webpack_public_path__ + "media/images/top/green_add-b5e83ce464876cf031ee000f6e244996.png";